import React from 'react';
import Tabs from '../../../Layout/Tabs';
import { Box, LinearProgress, Typography } from '@mui/material';
import FolderDetails from './FolderDetails';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { getFolder } from '../../../api/services';

const FileDetailsPage: React.FC = () => {

  const { id } = useParams<{ id?: string }>();

   // Fetch folder details with react-query
    const { data: folderData, isLoading, isError, refetch } = useQuery(
      ['folderData', id],
      () => getFolder(id || ''),
      { enabled: !!id }
    );


    if (isLoading) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', height: '100vh' }}>
          <LinearProgress sx={{ width: '100%', mt: 0.5 }} />
        </Box>
      );
    }
  
    if (isError || !folderData) {
      return (
        <Box sx={{ textAlign: 'center', marginTop: 4 }}>
          <Typography variant="h4" color="error">
            Folder Not Found
          </Typography>
        </Box>
      );
    }
  

    // console.log(folderData?.data);


  return (
    <>
        <FolderDetails folderData={folderData?.data} refetch={refetch} />
    </>
  );
};

export default FileDetailsPage;
